import classNames from 'classnames';
import { ChangeEvent, PureComponent, ReactNode } from 'react';
import './index.scss';

export interface Props {
  checked: boolean | number;
  disabled: boolean;
  id: string;
  testid?: string;
  label?: ReactNode;
  partiallyChecked: boolean | number;
  onChange?: (checked: boolean) => void;
  onChangeWithEvent?: (event: ChangeEvent<HTMLInputElement>) => void;
}

class ReactUiCheckbox extends PureComponent<Props> {
  public static defaultProps = {
    checked: false,
    disabled: false,
    partiallyChecked: false,
  };

  private onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { onChange, onChangeWithEvent, disabled } = this.props;
    if (!disabled) {
      if (onChange) {
        onChange(event.target.checked);
      }
      if (onChangeWithEvent) {
        onChangeWithEvent(event);
      }
    }
  };

  public render() {
    const { checked, partiallyChecked, disabled, id, label, testid } =
      this.props;
    const inputId = `checkbox-${id}`;
    return (
      <label id={id} className="ReactUiCheckbox" htmlFor={inputId}>
        <input
          type="checkbox"
          id={inputId}
          className="ReactUiCheckbox__input"
          checked={Boolean(checked) || Boolean(partiallyChecked)}
          onChange={this.onChange}
          disabled={disabled}
          data-testid={testid}
        />
        <i
          className={classNames('ReactUiCheckbox__checkbox', {
            ReactUiCheckbox__disabled: disabled,
            'ReactUiCheckbox__checkbox--checked': checked || partiallyChecked,
          })}
        >
          {checked || partiallyChecked ? (
            <i
              className={classNames('ReactUiCheckbox__checked mdi', {
                'mdi-check': checked,
                'mdi-minus': !checked,
                'mdi-disabled': disabled,
              })}
            />
          ) : (
            <i className="ReactUiCheckbox__blank mdi mdi-blank" />
          )}
        </i>
        {label && (
          <span
            className={classNames({
              ReactUiCheckbox__label: true,
              label__disabled: disabled,
            })}
          >
            {label}
          </span>
        )}
      </label>
    );
  }
}

export default ReactUiCheckbox;
export const Checkbox = ReactUiCheckbox;
